import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {BasicResponse, Auth0Resource, SortFilterInterface} from '../..';

export interface ResourceAPI {
  items: Auth0Resource[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class Auth0ResourceService {

  constructor( @Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }
  private URL;
  headers: HttpHeaders;

  private static handleHTTPError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }


  getResources(pageIndex: number, pageSize: number, sortActive: string, sort: string, sortFilter: SortFilterInterface): Observable<ResourceAPI> {

    const headers = this.headers;
    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient.post<ResourceAPI>(
        `${this.URL}/auth0/resource/${pageIndex}/${pageSize}/${sortActive}/${sort}`,sortFilter, {headers}).pipe(
        catchError(Auth0ResourceService.handleHTTPError)
    );

  }

  updateResource(resource: Auth0Resource): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.patch<BasicResponse>(`${this.URL}/auth0/resource/${resource.resourceID}`,
        resource, {headers})
        .pipe(
            catchError(Auth0ResourceService.handleHTTPError)
        );
  }

  createResource(resource: Auth0Resource): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.put<BasicResponse>(`${this.URL}/auth0/resource/`,
        resource, {headers})
        .pipe(
            catchError(Auth0ResourceService.handleHTTPError)
        );
  }

  getResource(id: string): Observable<Auth0Resource> {
    const headers = this.headers;
    return this.httpClient.get<Auth0Resource>(
        `${this.URL}/auth0/resource/${id}`, {headers}).pipe(
        catchError(Auth0ResourceService.handleHTTPError)
    );
  }
}
